import { ROUTE_ACTIONS } from './constants';

export const isApplicationsAction = (action) =>
  action?.toLowerCase() === ROUTE_ACTIONS.APPLICATIONS;

export const findApplicationTypeByCode = (applicationTypes, code) => {
  if (!code) return null;

  return (applicationTypes || []).find((applicationType) => {
    const possibleCodes = [
      applicationType?.code,
      applicationType?.name,
      applicationType?.id,
      applicationType?.slug,
    ].filter(Boolean);

    return possibleCodes.some(
      (possibleCode) => String(possibleCode) === String(code)
    );
  });
};

export const normalizeLanguageForPublicTypes = (language) =>
  language === 'gr' ? 'el' : language || 'en';

export const buildDeeplinkKey = (queryParams) =>
  [
    queryParams.action || '',
    queryParams.code || '',
    queryParams.authority || '',
    queryParams.country || '',
    queryParams.lang || '',
    queryParams.applicationsLicensePlate || '',
    queryParams.applicationsCode || '',
  ].join('|');

export const hasAnyDeeplinkParam = (queryParams) =>
  !!queryParams.action ||
  !!queryParams.code ||
  !!queryParams.authority ||
  !!queryParams.country ||
  !!queryParams.lang ||
  !!queryParams.applicationsLicensePlate ||
  !!queryParams.applicationsCode;
